/* global axios */
import ApiClient from './ApiClient';

class CampaignAbTestsAPI extends ApiClient {
  constructor() {
    super('ab_tests', { accountScoped: true, apiVersion: 'v1' });
  }

  // Override to include campaign_id in URL
  get url() {
    return `/api/v1/accounts/${this.accountIdFromRoute}/campaigns`;
  }

  getAll(campaignId) {
    return axios.get(`${this.url}/${campaignId}/ab_tests`);
  }

  get(campaignId, testId) {
    return axios.get(`${this.url}/${campaignId}/ab_tests/${testId}`);
  }

  create(campaignId, data) {
    return axios.post(`${this.url}/${campaignId}/ab_tests`, { ab_test: data });
  }

  update(campaignId, testId, data) {
    return axios.put(`${this.url}/${campaignId}/ab_tests/${testId}`, {
      ab_test: data,
    });
  }

  delete(campaignId, testId) {
    return axios.delete(`${this.url}/${campaignId}/ab_tests/${testId}`);
  }

  getStats(campaignId, testId) {
    return axios.get(`${this.url}/${campaignId}/ab_tests/${testId}/stats`);
  }

  selectWinner(campaignId, testId) {
    return axios.post(
      `${this.url}/${campaignId}/ab_tests/${testId}/select_winner`
    );
  }

  cancel(campaignId, testId) {
    return axios.post(`${this.url}/${campaignId}/ab_tests/${testId}/cancel`);
  }
}

export default new CampaignAbTestsAPI();
